export default __webpack_public_path__ + "static/media/titanicScene.5a235b2f.png";